import styled from 'styled-components';

export const ToggleButton = styled.td`
  padding: 8px 8px 8px 16px !important;
  width: 30px;
`;
